<template>
  <list-template :classCustom="'list-job'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              <h3 class="font-weight__bold">
                Báo cáo tiến độ hoàn thành công việc
              </h3>
            </div>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <el-form
                  ref="form"
                  :model="form"
                  label-position="top"
                  class="input-no__label"
                >
                  <el-row :gutter="24" class="leftSection margin-right-10">
                    <el-col
                      :span="18"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto"
                      >Khoảng thời gian</span
                      >

                      <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="dateRangeChanged"
                      ></el-date-picker>
                    </el-col>
                    <el-col
                      :span="2"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <el-button
                        class="btnSolid__blue"
                        size="medium"
                        @click="exportReport"
                      >
                        <i class="fas fa-mouse-pointer"></i>
                        &nbsp;Xem biểu đồ
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </sub-header>
          </template>
          <template #body>
            <div class="barChart" ref="barChartContainerDiv">
              <tien-do-hoan-thanh-cv-chart
                ref="chart"
                :width="chartSize.width"
                :height="chartSize.height"
              ></tien-do-hoan-thanh-cv-chart>
            </div>
          </template>
        </list-template>
      </div>
    </template>
  </list-template>
</template>

<script>
  import DocInBookReportCard from "../docInBookReportCard";
  import vbDocReportCard from "../vbDocReportCard";
  import TkReportCard from "../tk-report-card";
  import ListTemplate from "../../common/list";
  import MainHeader from "../../../components/header/main-header";
  import utils from "../../../services/utils";
  import constants from "../../../constants";
  import SubHeader from "../../../components/main/sub-header";
  import TienDoHoanThanhCvChart from "./tien-do-hoan-thanh-cv-chart";
  import dateUtils from "../../../dateUtils";
  import taskReportService from "../../../services/taskReportService";

  export default {
    name: "tien-do-hoan-thanh-cv",
    components: {
      TienDoHoanThanhCvChart,
      SubHeader,
      MainHeader,
      ListTemplate,
      TkReportCard,
      DocInBookReportCard,
      vbDocReportCard
    },

    computed: {},

    data() {
      return {
        form: {
          fromDate: null,
          toDate: null
        },
        dateRange: null,
        dateQuickFilterOption: null,
        REPORT: constants.REPORT,
        chartSize: {
          width: 100,
          heigth: 100
        }
      };
    },

    created() {
      this.initDateQuickFilterOption();
      this.initQuery();
    },

    mounted() {
      this.calculateChartSize();
      this.exportReport();
    },

    methods: {

      calculateChartSize() {
        this.chartSize.width = this.$refs.barChartContainerDiv.clientWidth;
        this.chartSize.height = this.$refs.barChartContainerDiv.clientHeight;
      },

      initDateQuickFilterOption() {
        this.dateQuickFilterOption = {
          shortcuts: [
            {
              text: "Tháng này",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
                  )
                );
              }
            },
            {
              text: "Tháng trước",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
                  )
                );
              }
            },
            {
              text: "Năm nay",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.NAM_NAY
                  )
                );
              }
            },
            {
              text: "Năm trước",
              onClick(picker) {
                picker.$emit(
                  "pick",
                  dateUtils.getDatesByQuickFilter(
                    constants.DATE_QUICK_FILTER.CODE.LAST_YEAR_2
                  )
                );
              }
            }
          ]
        };
      },

      initQuery() {
        this.form.fromDate = this.$route.query.fromDate
          ? parseInt(this.$route.query.fromDate)
          : null;
        this.form.toDate = this.$route.query.toDate
          ? parseInt(this.$route.query.toDate)
          : undefined;
        this.initDateRange();
      },

      initDateRange() {
        if (this.form.fromDate && this.form.toDate) {
          this.dateRange = [
            dateUtils.toMoment(this.form.fromDate),
            dateUtils.toMoment(this.form.toDate)
          ];
        } else {
          this.dateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          );
          let defaultTimeRange = dateUtils.getTimesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          );
          this.form.fromDate = defaultTimeRange[0];
          this.form.toDate = defaultTimeRange[1];
          this.storeParamsAtUrl();
        }
      },

      dateRangeChanged() {
        this.form.fromDate =
          this.dateRange && this.dateRange[0]
            ? this.dateRange[0].getTime()
            : undefined;
        this.form.toDate =
          this.dateRange && this.dateRange[1]
            ? this.dateRange[1].getTime()
            : undefined;
        this.exportReport();
      },

      buildQuery() {
        return {
          fromDate: this.form.fromDate || undefined,
          toDate: this.form.toDate || undefined
        };
      },

      validate() {
        return new Promise(resolve => {
          let diff;
          if (!this.form.fromDate || !this.form.toDate) {
            this.$message({
              message: "Khoảng thời gian (từ ngày/đến ngày) bắt buộc nhập",
              type: "error"
            });
            return;
          }
          let fromDate = dateUtils.toMoment(this.form.fromDate);
          let toDate = dateUtils.toMoment(this.form.toDate);
          diff = toDate.diff(fromDate, "day");
          if (diff < 0) {
            this.$message({
              message: "Trường Đến ngày không được nhỏ hơn trường tới ngày",
              type: "error"
            });
            return;
          }
          if (diff > 365) {
            this.$message({
              message: "Khoảng thời gian phải nhỏ hơn 1 năm",
              type: "error"
            });
            return;
          }
          resolve();
        });
      },

      storeParamsAtUrl() {
        let query = this.buildQuery();

        let routerQuery = utils.merge(this.$router.query, {
          fromDate: query.fromDate,
          toDate: query.toDate,
          reportType: this.reportType
        });

        this.$router.replace({
          name: this.$router.name,
          params: this.$router.params,
          query: routerQuery
        });
      },

      exportReport() {
        return this.validate().then(() => {
          this.storeParamsAtUrl();
          return taskReportService
            .tienDoHoanThanhReport({
              startDate: this.form.fromDate,
              endDate: this.form.toDate
            })
            .then(
              response =>
                this.$refs.chart && this.$refs.chart.loadData(response.data)
            );
        });
      }
    }
  };
</script>

<style scoped>
  .barChart {
    margin-top: 20px;
    height: calc(100% - 100px) !important;
    width: calc(100% - 10px) !important;
    position: relative;
  }

  /*.listCardReport {*/
  /*  margin: 12px 12px 0 -12px;*/
  /*}*/

  /*.listCardReport .scroll-area {*/
  /*  height: calc(100vh - 120px);*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/report/qlcv/tien-do-hoan-thanh-cv.vue